import { useQuery } from 'react-query';

import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { DealFinancialMetric, AnalysisMetricTypes, DealFinancialMetricType, Guid } from '../../models';
import { QueryKeys } from '.';

export function useDealFinancialMetricsQuery(
	dealGuid: Guid | undefined,
	analysisMetricType: AnalysisMetricTypes,
	metrics?: DealFinancialMetricType[]
) {
	const api = useApi();

	const [url, metricTypes] = CerebroApiEndpoints.Metrics.FilteredList(dealGuid, analysisMetricType, metrics);

	return useQuery<DealFinancialMetric[]>(
		QueryKeys.FinancialMetrics.Filtered(dealGuid, analysisMetricType, metricTypes),
		() => GetMetrics(api, url),
		{ enabled: dealGuid !== undefined }
	);
}

async function GetMetrics(api: ReturnType<typeof useApi>, url: string): Promise<DealFinancialMetric[]> {
	const metrics = await AxiosUtils.getResponseData<DealFinancialMetric[] | string>(api.get(url));

	if (typeof metrics === 'string') return [];

	return metrics;
}
